export const SLUG = {
  LOGIN: 'login',
  PASSWORD_RESET: 'password-reset',
  REGISTER: 'register',
  NEWS: 'news',
  NEWS_CREATE: 'create',
  NEWS_EDIT: 'edit',
  INVOICES: 'invoices',
  PAYMENTS: 'payments',
  SETTLEMENTS: 'settlements',
  BASKET: 'basket',
  BASKET_ORDER_CREATED: 'success',
  ORDERS: 'orders',
  ORDER_LINES: 'order-lines',
  SEARCH_RESULTS: 'search',
  ITEM: 'item',
  DOWNLOADS: 'downloads',
  PRICE_LIST: 'price-list',
  STOCK: 'stock',
  QUOTATIONS: 'quotation',
  QUOTATION_EDIT: 'edit',
  QUOTATION_ORDER_CREATED: 'success',
  ORDER_EDIT: 'edit',
  GLOBAL_PRICING: 'global-pricing',
  GLOBAL_PRICING_EDIT: 'edit',
  ADMIN: 'admin',
  CUSTOMER_LIST: 'customer-list',
  COMPANIES: 'companies',
  MANAGER_LIST: 'manager-list',
  NOTIFICATIONS: 'notifications',
  NOTIFICATIONS_CREATE: 'create',
  CONFIG: 'config',
  PRICE_COEFFICIENT: 'price-coefficient',
  PRICING_GROUPS: 'pricing-groups',
  CURRENCY_RATES: 'currency-rates',
  ACTIVE_CONTRACTS: 'active-contracts',
  REPORTS: 'reports',
  INVOICE_FORMS: 'invoice-forms',
  PROFILE: 'profile',
  PROFILE_GENERAL_INFO: 'general',
  PROFILE_NOTIFICATIONS: 'notifications',
  PROFILE_ADDRESSES: 'addresses',
  ID: ':id',
};

export const PATH = {
  ROOT_PAGE: '/',
  LOGIN_PAGE: `/${SLUG.LOGIN}`,
  PASSWORD_RESET_REQUEST_PAGE: `/${SLUG.PASSWORD_RESET}`,
  PASSWORD_RESET_PAGE: `/${SLUG.PASSWORD_RESET}/${SLUG.ID}`,
  REGISTER_PAGE: `/${SLUG.REGISTER}`,
  NEWS_PAGE: `/${SLUG.NEWS}`,
  NEWS_CREATE_PAGE: `/${SLUG.NEWS}/${SLUG.NEWS_CREATE}`,
  NEWS_EDIT_PAGE: `/${SLUG.NEWS}/${SLUG.ID}/${SLUG.NEWS_EDIT}`,
  INVOICES_PAGE: `/${SLUG.INVOICES}`,
  PAYMENTS_PAGE: `/${SLUG.PAYMENTS}`,
  SETTLEMENTS_PAGE: `/${SLUG.SETTLEMENTS}`,
  BASKET_PAGE: `/${SLUG.BASKET}`,
  BASKET_ORDER_CREATED_PAGE: `/${SLUG.BASKET}/${SLUG.BASKET_ORDER_CREATED}`,
  ORDERS_PAGE: `/${SLUG.ORDERS}`,
  ORDER_PAGE: `/${SLUG.ORDERS}/${SLUG.ID}`,
  ORDER_EDIT_PAGE: `/${SLUG.ORDERS}/${SLUG.ID}/${SLUG.ORDER_EDIT}`,
  ORDER_LINES_PAGE: `/${SLUG.ORDER_LINES}`,
  SEARCH_RESULTS_PAGE: `/${SLUG.SEARCH_RESULTS}`,
  ITEM_PAGE: `/${SLUG.ITEM}/${SLUG.ID}`,
  DOWNLOADS_PAGE: `/${SLUG.DOWNLOADS}`,
  PRICE_LIST_PAGE: `/${SLUG.DOWNLOADS}/${SLUG.PRICE_LIST}`,
  STOCK_PAGE: `/${SLUG.DOWNLOADS}/${SLUG.STOCK}`,
  QUOTATIONS_PAGE: `/${SLUG.QUOTATIONS}`,
  QUOTATION_PAGE: `/${SLUG.QUOTATIONS}/${SLUG.ID}`,
  QUOTATION_EDIT_PAGE: `/${SLUG.QUOTATIONS}/${SLUG.ID}/${SLUG.QUOTATION_EDIT}`,
  QUOTATION_ORDER_CREATED_PAGE: `/${SLUG.QUOTATIONS}/${SLUG.ID}/${SLUG.QUOTATION_ORDER_CREATED}`,
  GLOBAL_PRICING_LIST_PAGE: `/${SLUG.ADMIN}/${SLUG.GLOBAL_PRICING}`,
  GLOBAL_PRICING_PAGE: `/${SLUG.ADMIN}/${SLUG.GLOBAL_PRICING}/${SLUG.ID}`,
  GLOBAL_PRICING_EDIT_PAGE: `/${SLUG.ADMIN}/${SLUG.GLOBAL_PRICING}/${SLUG.ID}/${SLUG.GLOBAL_PRICING_EDIT}`,
  ADMIN_PAGE: `/${SLUG.ADMIN}`,
  CUSTOMER_LIST_PAGE: `/${SLUG.ADMIN}/${SLUG.CUSTOMER_LIST}`,
  COMPANIES_PAGE: `/${SLUG.ADMIN}/${SLUG.COMPANIES}`,
  MANAGER_LIST_PAGE: `/${SLUG.ADMIN}/${SLUG.MANAGER_LIST}`,
  NOTIFICATIONS_PAGE: `/${SLUG.ADMIN}/${SLUG.NOTIFICATIONS}`,
  NOTIFICATION_PAGE: `/${SLUG.ADMIN}/${SLUG.NOTIFICATIONS}/${SLUG.ID}`,
  NOTIFICATIONS_CREATE_PAGE: `/${SLUG.ADMIN}/${SLUG.NOTIFICATIONS}/${SLUG.NOTIFICATIONS_CREATE}`,
  CONFIG_PAGE: `/${SLUG.ADMIN}/${SLUG.CONFIG}`,
  PRICE_COEFFICIENTS_PAGE: `/${SLUG.ADMIN}/${SLUG.PRICE_COEFFICIENT}`,
  PRICING_GROUPS_PAGE: `/${SLUG.ADMIN}/${SLUG.PRICING_GROUPS}`,
  CURRENCY_RATES_PAGE: `/${SLUG.ADMIN}/${SLUG.CURRENCY_RATES}`,
  ACTIVE_CONTRACTS_PAGE: `/${SLUG.ADMIN}/${SLUG.ACTIVE_CONTRACTS}`,
  REPORTS_PAGE: `/${SLUG.ADMIN}/${SLUG.REPORTS}`,
  INVOICE_FORMS_PAGE: `/${SLUG.ADMIN}/${SLUG.INVOICE_FORMS}`,
  PROFILE_PAGE: `/${SLUG.PROFILE}`,
  PROFILE_GENERAL_INFO: `/${SLUG.PROFILE}/${SLUG.PROFILE_GENERAL_INFO}`,
  PROFILE_NOTIFICATIONS: `/${SLUG.PROFILE}/${SLUG.PROFILE_NOTIFICATIONS}`,
  PROFILE_ADDRESSES: `/${SLUG.PROFILE}/${SLUG.PROFILE_ADDRESSES}`,
};
